module.exports = __webpack_public_path__ + "img/logo.7fafa83a.png";